import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveTo16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveTo16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 1a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm0 1h2.5v1.5H4zm0 4.25a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1zm0 1h2.5v1.5H4zM3 12.5a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm3.5 0H4V14h2.5zm2.5-6a.5.5 0 0 0 1 0V4.536a4 4 0 0 1 1.999 3.463c0 1.48-.804 2.772-1.999 3.464V9.5a.5.5 0 0 0-1 0V13h3.5a.5.5 0 0 0 0-1h-1.502a5 5 0 0 0 2-4A5 5 0 0 0 11 4h1.5a.5.5 0 0 0 0-1H9z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoveTo16);
